import React from 'react';
import { css } from 'emotion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

const Textarea = ({ label, value, placeholder, handleChange, isLoading }) => {
  return (
    <div>
      {label ? (
        <label className={css(styles.wrapper)}>
          {label}
          <textarea
            rows={4}
            className="form-control mt-1"
            defaultValue={value || ''}
            placeholder={placeholder}
            onBlur={handleChange}
          />
        </label>
      ) : (
        <textarea
          rows={4}
          className="form-control"
          defaultValue={value || ''}
          placeholder={placeholder}
          onBlur={handleChange}
        />
      )}
      {isLoading && <FontAwesomeIcon icon={faSpinner} pulse />}
    </div>
  );
};

const styles = {
  wrapper: {
    width: '100%',
  },
};

export default Textarea;

